import { Component, OnInit, ViewEncapsulation, Inject, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { TicketDocumentInfo } from '../model/ticketdocument.model';
import { LookupInfo } from '../model/lookup.model';
import { EmpInfo } from '../model/emp.model';
import { TicketInfo } from '../model/ticket.model';
import { ProjectInfo } from '../model/project.model';
import { ContactlistInfo } from '../model/contactlist.model';
import { MappingTierInfo } from '../model/mappingtier.model';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpEventType } from '@angular/common/http';
import { GlobalService } from '../service/global.service';
import {
  environment
} from 'src/environments/environment';
import { TokenService } from '../service/token.service';
import { async } from '@angular/core/testing';


@Component({
  selector: 'app-ticket-form',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './ticket-form.component.html',
  styleUrls: ['./ticket-form.component.css']
})
export class TicketFormComponent implements OnInit, AfterViewInit {

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private GlobalService: GlobalService, private formBuilder: FormBuilder, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
  }

  @Output() UpdateValueModal = new EventEmitter<{ titlemodal: string, detailmodal: string }>();
  @Output() callbackload = new EventEmitter();

  //variable modal popup Attach Img
  AttachImgPath: string

  //variable input from parent component
  @Input() TicketList: TicketInfo[]
  @Input() titleparam: string
  @Input() displayiconback: boolean = false
  //variable for Request http
  baseurl: string = ''

  // variable emp
  RoleCode: string = ''


  // variable flag insert update
  isOnUpdate: boolean;
  isSubmitted: any;

  // variable ticket form

  @Input() TicketForm: FormGroup;

  hidTicketId: number = null
  hidTicketMappingTierCode: string = ''
  hidTicketMappingTierbyStatus: string = ''
  txtTicketID: string = null
  txtCreateDate: string = null
  @Input() _ParamProjectName: string = null
  @Input() _ParamProjectCode: string = null
  @Input() _ParamticketID: number = null

  txtWarrantyMAType: string = null
  txtWarrantyMaStartDate: string = null
  txtWarrantyMaEndDate: string = null
  txtWarrantySubStartDate: string = null
  txtWarrantySubEndDate: string = null
  txtWarrantyWarrantyStartDate: string = null
  txtWarrantyWarrantyEndDate: string = null
  txtTitle: string = null
  txtDescription: string = null
  txtSysptom: string = null
  txtProblemDate: string = null
  txtAttachCode: string = null
  TicketDocumentList: TicketDocumentInfo[] = []
  TicketDocumentRemovedList: any[] = []
  txtContactperson: string = null
  txtMailcontact: string = null
  txtCCmail: string = null
  ddlTicketStatus: string = null
  TicketLastStatus: string = null
  TicketStatusList: LookupInfo[] = []
  ddlRaiseby: string = null
  RaiseByList: EmpInfo[] = []
  ddlTicketState: string = null
  TicketStateList: LookupInfo[] = []
  TicketOwnerList: EmpInfo[] = []
  TicketOwnerTierList: ContactlistInfo[] = []
  GetTireByStatusList: MappingTierInfo[] = []
  ddlSeverity: string = null
  SeverityList: LookupInfo[] = []
  Checklist: any = null
  txtDeadline: string = null
  txtHistoryProgress: string = null
  lblHistoryProgress: string = null
  txtProjectSupportContractTypeCode: string = null;
  txtTicStatus: string = null;
  isConfirmStatus: boolean = false;
  // message: string = null;
  private _onConfirmStatusModal: () => void;
  private _onCancelModal: () => void;



  // variable for loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //variable modal from parent component

  @Input() titlemodal: string
  @Input() detailmodal: string


  //variable input file
  filesToUpload: File[]
  filesToUploadlength: number

  resultUploadfile: any;

  // access_token for query parameter
  access_token: string;


  async ngOnInit() {
    this.access_token = await this.TokenService.RefreshToken();

    // get EmpRole
    this.RoleCode = localStorage.getItem('EmpRoleCode');
    // set result upload file to null
    this.resultUploadfile = { type: null };
    //load project detail
    // load project detail
    this.LoadProjectList()
    //   .then(
    //     data => {
    //       console.log("pj === ", data);
    //       var countproject = data.length;
    //       // if (countproject > 0) {
    //       //   this.txtWarrantyMAType = data[0].ProjectWarrantyTypeName != null ? data[0].ProjectWarrantyTypeName : '';
    //       //   this.txtWarrantyMAType += ' / ';
    //       //   this.txtWarrantyMAType += data[0].ProjectMATypeName != null ? data[0].ProjectMATypeName : '';

    //       //   if (data[0].ProjectSupportContractTypeDisplay == 'Ma') {
    //       //     this.txtWarrantyMaStartDate = data[0].ProjectMAStart != null ? this.formatDateExcel(data[0].ProjectMAStart) : '';
    //       //     this.txtWarrantyMaEndDate = data[0].ProjectMAEnd != null ? this.formatDateExcel(data[0].ProjectMAEnd) : '';
    //       //   } else if (data[0].ProjectSupportContractTypeDisplay == 'Warranty') {
    //       //     this.txtWarrantyMaStartDate = data[0].ProjectWarrantyStart != null ? this.formatDateExcel(data[0].ProjectWarrantyStart) : '';
    //       //     this.txtWarrantyMaEndDate = data[0].ProjectWarrantyEnd != null ? this.formatDateExcel(data[0].ProjectWarrantyEnd) : '';
    //       //   }
           

    //       // }
    //     }
    //   );


    // load check list task
    await this.loadChecklist().then((data) => {
      this.Checklist = data
    });

    // load master
    this.loadDDLStatus();
    this.loadDDLRaiseBy();
    //this.loadDDLTicketOwner();
    this.loadListEmpOwnerbyTier();
    this.loadDDLSeverity();

  }

  ngAfterViewInit() {
    // if ticket id not empty
    if (this._ParamticketID) {
      $('#WorklistZone').hide();
      $('#TicketDetailZone').show();

      this.btnClick_onUpdateTicket(this._ParamticketID);
    }
  }

 

  // -------------------------------------------------------- Event Action Zone ------------------------------------------------------------------------
  //Function New Ticket on click
  btnClick_onInsertTicket() {
    this.TicketForm.reset();
    this.clearInsertSection();

    this.isOnUpdate = false
    $('#filer_input1').val('')
    if (document.querySelectorAll('#InsertSectionTicket').length) {
      document.getElementById("InsertSectionTicket").style.display = "block"
    }
  }


  // Function onclick ticket for update
  async btnClick_onUpdateTicket(id) {
    var existCondition = setInterval(async () => {
      if (this.TicketList != undefined) {
    console.log("Exists!");
    clearInterval(existCondition);

   this.TicketForm.reset();

   if (document.querySelectorAll('#InsertSectionTicket').length) {
     document.getElementById("InsertSectionTicket").style.display = "block"
     document.querySelector('#InsertSectionTicket').scrollIntoView();
   }
   $('#filer_input1').val('');
   this.TicketDocumentRemovedList = []; // set remove acttach file list to empty
   this.isOnUpdate = true

   // load project detail
   this.LoadProjectList()
     .then(
       data => {
        console.log("xxxxxx == ", data);
         var countproject = data.length;
         if (countproject > 0) {
          //  this.txtWarrantyMAType = data[0].ProjectWarrantyTypeName != null ? data[0].ProjectWarrantyTypeName : '';
          //  this.txtWarrantyMAType += ' / ';
          //  this.txtWarrantyMAType += data[0].ProjectMATypeName != null ? data[0].ProjectMATypeName : '';
          // this.txtWarrantyMAType = data[0].ProjectStateName

          this.txtProjectSupportContractTypeCode = data[0].ProjectSupportContractTypeCode

          if(data[0].ProjectSupportContractTypeDisplay != null){
            this.txtWarrantyMAType = data[0].ProjectSupportContractTypeDisplay;
          }else{
            this.txtWarrantyMAType = data[0].ProjectSupportContractTypeValue;
          }

          if(this.txtProjectSupportContractTypeCode == '1'){
           this.txtWarrantyWarrantyStartDate = data[0].ProjectWarrantyStart != null ? this.formatDateExcel(data[0].ProjectWarrantyStart) : '';
           this.txtWarrantyWarrantyEndDate = data[0].ProjectWarrantyEnd != null ? this.formatDateExcel(data[0].ProjectWarrantyEnd) : '';
          }else if(this.txtProjectSupportContractTypeCode == '2'){

           this.txtWarrantyMaStartDate = data[0].ProjectMAStart != null ? this.formatDateExcel(data[0].ProjectMAStart) : '';
           this.txtWarrantyMaEndDate = data[0].ProjectMAEnd != null ? this.formatDateExcel(data[0].ProjectMAEnd) : '';

          }else if(this.txtProjectSupportContractTypeCode == '4'){
           this.txtWarrantySubStartDate = data[0].ProjectSubscriptStart != null ? this.formatDateExcel(data[0].ProjectSubscriptStart) : '';
           this.txtWarrantySubEndDate = data[0].ProjectSubscriptEnd != null ? this.formatDateExcel(data[0].ProjectSubscriptEnd) : '';

          }


         } else {
           this.txtWarrantyMAType = null;
           this.txtWarrantyMaStartDate = null;
           this.txtWarrantyMaEndDate = null;
         }
       }
     );


   let index = this.TicketList.findIndex(x => x.TicketId == id);
   this._ParamProjectCode = this.TicketList[index].ProjectCode != null ? this.TicketList[index].ProjectCode : null
   this.hidTicketMappingTierCode = this.TicketList[index].TicketMappingTierCode != null ? this.TicketList[index].TicketMappingTierCode : null
   this.txtTicketID = this.TicketList[index].TicketId != null ? this.TicketList[index].TicketId.toString() : null
   this.txtCreateDate = this.TicketList[index].CreateDate != null ? this.GetDateWithtime(this.TicketList[index].CreateDate) : null

   this.ddlTicketStatus = this.TicketList[index].TicketStatusCode != null ? this.TicketList[index].TicketStatusCode : null
   this.TicketLastStatus = this.TicketList[index].TicketStatusCode != null ? this.TicketList[index].TicketStatusCode : null
  //  this.txtTicStatus = this.TicketList[index].TicketStatusCode;

   this.txtContactperson = this.TicketList[index].ContactPerson != null ? this.TicketList[index].ContactPerson : null
   this.txtMailcontact = this.TicketList[index].MailContact != null ? this.TicketList[index].MailContact : null
   this.txtCCmail = this.TicketList[index].Ccmail != null ? this.TicketList[index].Ccmail : null

   var StatusName = this.TicketList[index].TicketStatusName != null ? this.TicketList[index].TicketStatusName : null

   // load state by status
   await this.loadDDLState(StatusName);

   // load owner tire
   this.loadListEmpOwnerbyTier();

   this.ddlTicketState = this.TicketList[index].TicketStateCode != null ? this.TicketList[index].TicketStateCode : null
   this.ddlSeverity = this.TicketList[index].SeverityCode != null ? this.TicketList[index].SeverityCode : null
   this.txtDeadline = this.TicketList[index].DeadlineDate != null ? this.GetDateWithtime(this.TicketList[index].DeadlineDate) : null

   this.lblHistoryProgress = this.TicketList[index].HistoryProgress



   this.TicketForm.patchValue({
     txtTitle: this.TicketList[index].Title,
     txtDescription: this.TicketList[index].Description,
     txtSysptom: this.TicketList[index].Sysptom,
     txtProblemDate: this.TicketList[index].ProblemDate,
     txtAttachCode: this.TicketList[index].AttachCode,
     txtContactperson: this.TicketList[index].ContactPerson,
     txtMailcontact: this.TicketList[index].MailContact,
     txtCCmail: this.TicketList[index].Ccmail,
     ddlTicketStatus: this.ddlTicketStatus,
     ddlTicketState: this.TicketList[index].TicketStateCode != null ? this.TicketList[index].TicketStateCode : null,
     txtDeadline: this.TicketList[index].DeadlineDate != null ? this.GetDateWithtime(this.TicketList[index].DeadlineDate) : null,
     ddlRaiseby: this.TicketList[index].RaiseByCode != null ? this.TicketList[index].RaiseByCode : null,
     ddlSeverity: this.TicketList[index].SeverityCode != null ? this.TicketList[index].SeverityCode : null,
     txtHistoryProgress: null,
   });

   // rest api get document ticket from Ticket Id
   this.TicketDocumentList = await this.GetTicketDocument(id);

   this.hidTicketId = this.TicketList[index].TicketId

   var checklistarrayobject = this.TicketList[index].ChecklistObject != null ? JSON.parse(this.TicketList[index].ChecklistObject) : null

   var controlsgroup = this.TicketForm.get('Checklist') as FormArray;
   var contraolarray = controlsgroup.controls;

   if (checklistarrayobject != null) {
     checklistarrayobject.forEach((traget, indextraget) => {
       var indextraget = this.Checklist.findIndex(x => x.ChecklistId == traget.ChecklistId);
       // set checkbox
       contraolarray[indextraget].setValue(traget.value);
     });
   }

 }
}, 100); // check every 100ms
  

  }


  selectFileOnChange(traget) {
    if (traget.currentTarget.files.length) {
      var fileName = traget.currentTarget.files[0].name;
      this.filesToUpload = traget.currentTarget.files;
      this.filesToUploadlength = this.filesToUpload.length;
    } else {
      this.filesToUploadlength = 0;

    }
  }

  btnclearfile_click() {
    $('#filer_input1').val('')
    this.filesToUploadlength = 0;

  }
 

  checkChangeTicketStatus(newDdlTicketStatus: string): Promise<boolean> {
    return new Promise((resolve) => {
      console.log("checkChangeTicketStatus()..", newDdlTicketStatus);
      console.log('old status === ', this.TicketLastStatus);

      if (newDdlTicketStatus !== this.TicketLastStatus) {
        // this.message = 'new status';

        this._onConfirmStatusModal = () => {
          $('#ModalConfirmStatus').modal('hide');
          resolve(true);
        };

        this._onCancelModal = () => {
          $('#ModalConfirmStatus').modal('hide');
          resolve(false); 
        };

        $('#ModalConfirmStatus').modal('show');
      } else {
        resolve(true); 
      }
    });
  }


  // ------------------------------------------------------ End Event Action Zone ------------------------------------------------------------------------


  // -------------------------------------------------------- Rest api Zone ------------------------------------------------------------------------
  async btnClick_submitInsertTicket() {


    if (this.TicketForm.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        var flagInsertDocumentTicket = null;
        this.loading(true, 'Saving ...');

        if (document.querySelectorAll('#InsertSectionTicket').length) {
          document.getElementById("InsertSectionTicket").style.display = "block"
        }
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        if (this.txtHistoryProgress == null) {
          this.txtHistoryProgress = '';
        }
        this.txtHistoryProgress = this.txtHistoryProgress.replace(/\r?\n/g, '<br />');

        this.txtHistoryProgress = this.txtHistoryProgress.split('"').join('&#34');

        this.txtHistoryProgress = this.txtHistoryProgress.split('\'').join('&#39');

        this.txtHistoryProgress = `<div class="card bg_color_green mt-3">
    <div class="card-body">
        <span class="font-weight-bold">` + this.GetDateWithtime() + `</span>
        <span class="font-weight-bold ml-3"> Status : ` + $('[formcontrolname="ddlTicketStatus"]').find('option:selected').text().trim() + `</span>

        <span class="font-weight-bold ml-3"> By : ` + localStorage.getItem('EmpName_TH') + `</span><br />
        <span class="font-weight-bold">Comment :</span>
        <div style="max-height: none;">
           `+ this.txtHistoryProgress + `
        </div>
    </div>
</div>
`;



        var checklistcontrol = this.TicketForm.get('Checklist').value;
        var checklistobjectarray = [];
        this.Checklist.forEach((traget, indextraget) => {
          var checklistobject = {};
          checklistobject['ChecklistId'] = traget.ChecklistId;
          checklistobject['value'] = checklistcontrol[indextraget] != null ? checklistcontrol[indextraget] : false;
          checklistobjectarray.push(checklistobject);
        });


        var objectjson = {};
        objectjson['TicketStatusCode'] = this.checkUndefinedString(this.ddlTicketStatus);
        objectjson['TicketStatusName'] = this.checkUndefinedString($('[formcontrolname="ddlTicketStatus"]').find(":selected").attr('statusname'));
        objectjson['TicketStateCode'] = this.checkUndefinedString(this.ddlTicketState);
        objectjson['RaiseByCode'] = this.checkUndefinedString(this.ddlRaiseby);
        objectjson['RaiseByName'] = this.checkUndefinedString($('[formcontrolname="ddlRaiseby"]').find(":selected").attr('empname'));
        objectjson['RaiseByRole'] = this.checkUndefinedString(this.RoleCode);
        objectjson['RaiseByMail'] = this.checkUndefinedString(localStorage.getItem("EmpMail"));
        objectjson['Title'] = this.checkUndefinedString(this.txtTitle);
        objectjson['SeverityCode'] = this.checkUndefinedString(this.ddlSeverity);
        objectjson['ProjectCode'] = this.checkUndefinedString(this._ParamProjectCode);
        objectjson['ProjectName'] = this.checkUndefinedString(this._ParamProjectName);
        objectjson['HistoryProgressLasted'] = this.checkUndefinedString(this.txtHistoryProgress);
        objectjson['HistoryProgress'] = this.checkUndefinedString(this.txtHistoryProgress);
        objectjson['Description'] = this.checkUndefinedString(this.txtDescription);
        objectjson['Sysptom'] = this.checkUndefinedString(this.txtSysptom);
        objectjson['ProblemDate'] = this.checkUndefinedString(this.txtProblemDate);
        objectjson['AttachCode'] = this.checkUndefinedString(this.txtAttachCode);
        objectjson['ContactPerson'] = this.checkUndefinedString(this.txtContactperson);
        objectjson['MailContact'] = this.checkUndefinedString(this.txtMailcontact);
        objectjson['Ccmail'] = this.checkUndefinedString(this.txtCCmail);

        objectjson['ActionByEmpCode'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['ChecklistObject'] = JSON.stringify(checklistobjectarray);

        // set hyperlink to send mail
        objectjson['link'] = 'http://' + window.location.hostname + ':' + window.location.port + '/ticket-management?ProjectCode=' + this._ParamProjectCode + '&ProjectName=' + this._ParamProjectName + '';

        objectjson['FlagDelete'] = "N";

        // console.log("insert tic == ", objectjson);
        let strjson = JSON.stringify(objectjson);

        // console.log("insert tic2 == ", this.txtHistoryProgress);
      

        this.isSubmitted = this.httpClient.post<TicketInfo[]>(this.baseurl + "Ticket/InsertTicket", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
            this.loading(false);

            this.titlemodal = 'Insert Ticket fail.';
            this.detailmodal = 'Your Ticket was Insert fail.';
            this.UpdateValueModal.emit({ titlemodal: this.titlemodal, detailmodal: this.detailmodal });

            $('#ModalError').modal();

          },
            async () => {

              this.resultUploadfile = await this.uploadfile(this.filesToUpload);


              if (this.resultUploadfile.type === HttpEventType.Response) {
                if (this.resultUploadfile.body.list.length > 0) {
                  // replace path file 
                  for (var iticketdocument = 0; iticketdocument < this.resultUploadfile.body.list.length; iticketdocument++) {
                    this.resultUploadfile.body.list[iticketdocument].dbPath = this.resultUploadfile.body.list[iticketdocument].dbPath.replace(String.fromCharCode(92), "/");
                  }
                  flagInsertDocumentTicket = await this.InsertTicketDocument(this.isSubmitted, this.resultUploadfile.body.list);
                }

              } else if (this.resultUploadfile == false) {  // file upload empty
                flagInsertDocumentTicket = true;
              }

              console.log("this.isSubmitted = ", this.isSubmitted);

              // call send email service
              this.SendMailTicket(this.isSubmitted).then((data) => {
              });



              console.log("Insert = " + this.isSubmitted)
              this.loading(false);

              this.titlemodal = 'Sent the matter to the support.';
              this.detailmodal = 'We\'ve received your ticket.Will get back to you soon.';
              this.UpdateValueModal.emit({ titlemodal: this.titlemodal, detailmodal: this.detailmodal });

              $('#ModalComplate').modal();

              this.clearInsertSection()
              // callback to parent component for load data after insert
              this.callbackload.emit();
            }
          )
      }
    }
    else {
      this.markFormGroupTouched(this.TicketForm as FormGroup);

    }
  }

  async btnClick_submitUpdateTicket(id) {

    if (this.TicketForm.valid) {


     let isConfirmed = await this.checkChangeTicketStatus(this.ddlTicketStatus);
     console.log("isConfirmed =", isConfirmed);

      if(isConfirmed){
        this.loading(true, 'Saving ...');
        this.updateTicket(id);
      }else{

      }
      

    } else {
      this.markFormGroupTouched(this.TicketForm as FormGroup);

    }


  }

  async updateTicket(id){
    var flagInsertDocumentTicket = null;
    var flagRemoveDocumentTicket = null;

    // -------------------------------------------------------- Upload Ticket File -----------------------------------------------------------
      this.resultUploadfile = await this.uploadfile(this.filesToUpload);


      if (this.resultUploadfile.type === HttpEventType.Response) {

        if (this.resultUploadfile.body.list.length > 0) {
          // replace path file 
          for (var iticketdocument = 0; iticketdocument < this.resultUploadfile.body.list.length; iticketdocument++) {
            this.resultUploadfile.body.list[iticketdocument].dbPath = this.resultUploadfile.body.list[iticketdocument].dbPath.replace(String.fromCharCode(92), "/");
          }
          flagInsertDocumentTicket = await this.InsertTicketDocument(this.hidTicketId, this.resultUploadfile.body.list);
        }

      } else if (this.resultUploadfile == false) {  // file upload empty
        flagInsertDocumentTicket = true;
      }
      // -------------------------------------------------------- End Upload Ticket File -----------------------------------------------------------

      // -------------------------------------------------------- Remove Ticket File -----------------------------------------------------------
      flagRemoveDocumentTicket = await this.RemoveTicketDocument(this.TicketDocumentRemovedList);

      // -------------------------------------------------------- End Remove Ticket File -----------------------------------------------------------



      // check insert document ticket success
      if (flagInsertDocumentTicket == true && flagRemoveDocumentTicket == true) {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          if (document.querySelectorAll('#InsertSectionTicket').length) {
            document.getElementById("InsertSectionTicket").style.display = "block"
          }
          id = this.hidTicketId
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };


          let strreplace = "<br><font color=red>";



          if (this.txtHistoryProgress == null) {
            this.txtHistoryProgress = '';
          }
          this.txtHistoryProgress = this.txtHistoryProgress.replace(/\r?\n/g, '<br />');

          this.txtHistoryProgress = this.txtHistoryProgress.split('"').join('&#34');

          this.txtHistoryProgress = this.txtHistoryProgress.split('\'').join('&#39');

          this.txtHistoryProgress = `<div class="card bg_color_green mt-3">
    <div class="card-body">
        <span class="font-weight-bold">` + this.GetDateWithtime() + `</span>
        <span class="font-weight-bold ml-3"> Status : ` + $('[formcontrolname="ddlTicketStatus"]').find('option:selected').text().trim() + `</span>

        <span class="font-weight-bold ml-3"> By : ` + localStorage.getItem('EmpName_TH') + `</span><br />
        <span class="font-weight-bold">Comment :</span>
        <div style="max-height: none;">
           `+ this.txtHistoryProgress + `
        </div>
    </div>
</div>
`;
          this.lblHistoryProgress = this.txtHistoryProgress + this.lblHistoryProgress;


          var checklistcontrol = this.TicketForm.get('Checklist').value;
          var checklistobjectarray = [];
          this.Checklist.forEach((traget, indextraget) => {
            var checklistobject = {};
            checklistobject['ChecklistId'] = traget.ChecklistId;
            checklistobject['value'] = checklistcontrol[indextraget] != null ? checklistcontrol[indextraget] : false;
            checklistobjectarray.push(checklistobject);
          });

          var objectjson = {};

          objectjson['TicketStatusCode'] = this.checkUndefinedString(this.ddlTicketStatus);
          objectjson['TicketStatusName'] = this.checkUndefinedString($('[formcontrolname="ddlTicketStatus"]').find(":selected").attr('statusname'));
          objectjson['TicketLastStatusName'] = this.checkUndefinedString(this.TicketLastStatus);
          objectjson['TicketStateCode'] = this.checkUndefinedString(this.ddlTicketState);
          objectjson['Title'] = this.checkUndefinedString(this.txtTitle);
          objectjson['SeverityCode'] = this.checkUndefinedString(this.ddlSeverity);
          objectjson['ProjectCode'] = this.checkUndefinedString(this._ParamProjectCode);
          objectjson['ProjectName'] = this.checkUndefinedString(this._ParamProjectName);
          objectjson['HistoryProgressLasted'] = this.checkUndefinedString(this.txtHistoryProgress);
          objectjson['HistoryProgress'] = this.checkUndefinedString(this.lblHistoryProgress);
          objectjson['Description'] = this.checkUndefinedString(this.txtDescription);
          objectjson['Sysptom'] = this.checkUndefinedString(this.txtSysptom);
          objectjson['ProblemDate'] = this.checkUndefinedString(this.txtProblemDate);
          objectjson['AttachCode'] = this.checkUndefinedString(this.txtAttachCode);
          objectjson['ContactPerson'] = this.checkUndefinedString(this.txtContactperson);
          objectjson['MailContact'] = this.checkUndefinedString(this.txtMailcontact);
          objectjson['Ccmail'] = this.checkUndefinedString(this.txtCCmail);
          objectjson['TicketId'] = id;

          objectjson['ActionByEmpCode'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
          objectjson['ChecklistObject'] = JSON.stringify(checklistobjectarray);

          // set hyperlink to send mail
          objectjson['link'] = 'http://' + window.location.hostname + ':' + window.location.port + '/ticket-management?ProjectCode=' + this._ParamProjectCode + '&ProjectName=' + this._ParamProjectName + '';


          let strjson = JSON.stringify(objectjson);
          console.log("strjson = ", strjson);

          this.isSubmitted = this.httpClient.post<TicketInfo[]>(this.baseurl + "Ticket/UpdateTicket", strjson, httpOptions)

            .subscribe(result => this.isSubmitted = result, failCb => {
              console.log("Update fail")

              this.loading(false);

              this.titlemodal = 'Update Ticket fail.';
              this.detailmodal = 'Your Ticket was Update fail.';
              this.UpdateValueModal.emit({ titlemodal: this.titlemodal, detailmodal: this.detailmodal });

              $('#ModalError').modal();

            },
              () => {
                // if current status not same last status
                if (this.ddlTicketStatus != this.TicketLastStatus) {

                  // call send email service
                  this.SendMailTicket(this.hidTicketId).then((data) => {
                  });

                }
                console.log("Update = " + this.isSubmitted)

                this.loading(false);

                this.titlemodal = 'Update Ticket done.';
                this.detailmodal = 'Your Ticket was updated successfully.';
                this.UpdateValueModal.emit({ titlemodal: this.titlemodal, detailmodal: this.detailmodal });

                $('#ModalComplate').modal();

                this.clearInsertSection();
                // callback to parent component for load data after update
                this.callbackload.emit();

              }
            )
        }
      } else {   // end check insert document ticket success
        this.loading(false);
        this.titlemodal = 'Update Ticket fail.';
        this.detailmodal = 'Your Ticket was updated successfully but your attach file upload or remove attach file fail.';
        this.UpdateValueModal.emit({ titlemodal: this.titlemodal, detailmodal: this.detailmodal });
        $('#ModalError').modal();

      }

  }


  //Function SendEmail
  async SendMailTicket(TicketId) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['TicketId'] = TicketId;
      objectjson['ProjectCode'] = this._ParamProjectCode;
      objectjson['ActionByEmpCode'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
      let strjson = JSON.stringify(objectjson);
      // console.log("strjson ticket === ", strjson);

      return await this.httpClient.post(this.baseurl + "Ticket/SendMailTicket", strjson, httpOptions)
        .toPromise();
    }
  }


  //Function Insert Document Ticket
  async InsertTicketDocument(TicketId, list) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['TicketDocumentTicketId'] = TicketId;
      objectjson['TicketDocumentCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));;
      objectjson['ListTicketDocument'] = list;
      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post(this.baseurl + "TicketDocument/InsertTicketDocument", strjson, httpOptions)
        .toPromise();
    }
  }

  //Function Remove Document Ticket
  async RemoveTicketDocument(Removelist) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ListTicketDocumentRemove'] = Removelist;
      objectjson['TicketDocumentUpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));;
      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post(this.baseurl + "TicketDocument/DeleteTicketDocument", strjson, httpOptions)
        .toPromise();
    }

  }


  // Function Get Ticket Documents
  async GetTicketDocument(TicketId) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['TicketDocumentTicketId'] = TicketId;
      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<TicketDocumentInfo[]>(this.baseurl + "TicketDocument/GetTicketDocument", strjson, httpOptions)
        .toPromise();
    }
  }


  // load project detail
  async LoadProjectList(): Promise<ProjectInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectCode'] = this.checkUndefinedString(this._ParamProjectCode);

      let strjson = JSON.stringify(objectjson);


      return this.httpClient
        .post<ProjectInfo[]>(this.baseurl + "Project/GetProjectCriteria",
          strjson, httpOptions).toPromise()
    }

  }



  // -------------------------------------------------------- End Rest api Zone ------------------------------------------------------------------------



  //Function save remove Ticklet Document
  btniconclose_onclick(TicketDocumentId) {
    // remove attach file from list by Ticket Document Id
    let index = this.TicketDocumentList.findIndex(x => x.TicketDocumentId == TicketDocumentId);
    this.TicketDocumentList.splice(index, 1);
    // save remove attach file
    this.TicketDocumentRemovedList.push(parseInt(TicketDocumentId));
  }

  // Function Status On Change
  async StatusOnchange(traget) {
    var status = $(traget.currentTarget).find('option:selected').text().trim();
    var statuscode = $(traget.currentTarget).find('option:selected').attr('ng-reflect-ng-value');
    this.loadDDLState(status);

    await this.GetTireByStatus(statuscode).then((data) => {
      this.GetTireByStatusList = data
    });

    if (this.GetTireByStatusList.length > 0) {
      this.hidTicketMappingTierbyStatus = this.GetTireByStatusList[0].MappingTierCode;
    } else {
      this.hidTicketMappingTierbyStatus = null;
    }

    this.loadListEmpOwnerbyStatus(this.hidTicketMappingTierbyStatus);


  }


  // ------------------------------------------------------------------- Get master Zone -----------------------------------------------------------------------------------



  //Function Get Ticket Status
  async loadDDLStatus() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjson = "{\"LookupType\":\"TICKETSTATUS\" }";

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.TicketStatusList = data
          // console.log("this.TicketStatusList == ", this.TicketStatusList);
        })
    }
  }


  // Function Get Master Emp for RaiseBy
  async loadDDLRaiseBy() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjson = "{\"EmpCode\":\"\" }";

      this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
        .toPromise().then((data) => {
          this.RaiseByList = data
        })
    }
  }


  // Function Get State Status

  async loadDDLState(Status: string) {
        console.log("status == ", Status);
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.ddlTicketState = null;
      if (Status != null && Status != '') {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        let strjson = "{\"LookupType\":\"" + Status + "\" }";
        // console.log(auth_token);
        // console.log("strjson = " + strjson);

       await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
          .toPromise().then((data) => {
            this.TicketStateList = data
            // console.log("TicketStateList == ", this.TicketStateList);
          })
      }
    }

  }


  //Function Get Master Emp for Ticket Owner
  async loadDDLTicketOwner() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjson = "{\"EmpCode\":\"\" }";

      this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
        .toPromise().then((data) => {
          this.TicketOwnerList = data
        })
    }
  }


  // Function Get Master Severity

  async loadDDLSeverity() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"LookupType\":\"TICKETSEVERITY\" }";

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SeverityList = data
        })
    }
  }

  //Fnction Get Checklist master
  async loadChecklist() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{}";

      return await this.httpClient.post<any>(this.baseurl + "Checklist/GetChecklist", strjson, httpOptions)
        .toPromise()
    }
  }


  //Function Get Master Emp for Ticket Owner by Tier
  async loadListEmpOwnerbyTier() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.TicketOwnerTierList = [];
      if (this.ddlTicketStatus != "8") { // if status is not closed
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        let tier = this.getContactlistRoleTier(this.ddlTicketStatus);
        console.log("this.ddlTicketStatus == ", this.ddlTicketStatus);
        // if (!this.GlobalService.checkUndefinedString(this.hidTicketMappingTierCode)) {
        //    this.hidTicketMappingTierCode = "1";
        // }
        var objectjson = {};
        objectjson['ContactlistProjectCode'] = this._ParamProjectCode;
        objectjson['ContactlistRoleTier'] = tier;
        objectjson['ContactlistSupportStatus'] = "Y";



        let strjson = JSON.stringify(objectjson);

        // console.log("xxx1 = ", strjson);

        this.httpClient.post<ContactlistInfo[]>(this.baseurl + "Contactlist/GetContactlist", strjson, httpOptions)
          .toPromise().then((data) => {
            // cut dupplicate
            data = data.filter((thing, index, self) =>
              index === self.findIndex((t) => (
                t.ContactlistEmpCode === thing.ContactlistEmpCode
              ))
            )
            this.TicketOwnerTierList = data
          })
      }
    }

  }

  //Fnction Get Tire by Status
  async GetTireByStatus(statuscode) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.TicketOwnerTierList = [];
      if (this.GlobalService.checkUndefinedString(statuscode)) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['MappingTierStatus'] = this.GlobalService.checkUndefinedString(statuscode);
        let strjson = JSON.stringify(objectjson);
        // console.log("xxx2 = ", strjson);

        return await this.httpClient.post<MappingTierInfo[]>(this.baseurl + "MappingTier/GetMappingTier", strjson, httpOptions)
          .toPromise()
      }
    }
  }


  //Function Get Master Emp for Ticket Owner by Status
  async loadListEmpOwnerbyStatus(TierCode) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.TicketOwnerTierList = [];
      if (this.ddlTicketStatus != "8") { // if status is not closed
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };


        var objectjson = {};
        objectjson['ContactlistProjectCode'] = this._ParamProjectCode;
        objectjson['ContactlistRoleTier'] = TierCode;
        objectjson['ContactlistSupportStatus'] = "Y";



        let strjson = JSON.stringify(objectjson);
        // console.log("xxx3 = ", strjson);

        this.httpClient.post<ContactlistInfo[]>(this.baseurl + "Contactlist/GetContactlist", strjson, httpOptions)
          .toPromise().then((data) => {
            // cut dupplicate
            data = data.filter((thing, index, self) =>
              index === self.findIndex((t) => (
                t.ContactlistEmpCode === thing.ContactlistEmpCode
              ))
            )

            this.TicketOwnerTierList = data
          })
      }
    }

  }

  // ------------------------------------------------------------------- End Get master Zone -----------------------------------------------------------------------------------


  // Function Create control array

  createAction(actionInputs) {
    const arr = actionInputs.map(action => {
      return new FormControl(action.selected || false);
    });
    return new FormArray(arr);
  }

  // Function Clear Insert
  clearInsertSection() {
    this.txtHistoryProgress = null
    this.lblHistoryProgress = null
    this.txtDescription = null
    this.txtSysptom = null
    this.txtProblemDate = null

    this.txtAttachCode = null


    if (this.RoleCode != 'CUSTOMER') {
      this.hidTicketMappingTierCode = '1' // set tire code to 1
      this.TicketForm.controls['ddlTicketStatus'].setValue(null);
      this.TicketForm.controls['ddlTicketState'].setValue(null);
    } else {
      this.hidTicketMappingTierCode = null // set tire code to null
      this.TicketForm.controls['ddlTicketStatus'].setValue('1');
      this.TicketForm.controls['ddlTicketState'].setValue('1');
      this.ddlTicketStatus = '1';
      this.ddlTicketState = '1';


    }
    this.TicketStateList = [];
    this.TicketDocumentList = [];
    this.TicketDocumentRemovedList = [];
    this.txtDeadline = null

    this.TicketForm.controls['ddlRaiseby'].setValue(localStorage.getItem('EmpCode'));
    this.txtTitle = null
    this.hidTicketId = null
    if (document.querySelectorAll('#InsertSectionTicket').length) {
      document.getElementById("InsertSectionTicket").style.display = "none"
    }

    // show worklist zone
    $('#WorklistZone').show();
    $('#TicketDetailZone').hide();
  }

  //Function convert date format with time
  GetDateWithtime(Datevalue: string = null) {
    return this.GlobalService.GetDateWithtime(Datevalue);
  }

  //Function convert date format for input date
  formatDate(date) {
    return this.GlobalService.formatDate(date);

  }

  //Function convert date format
  formatDateExcel(date) {
    return this.GlobalService.formatDateExcel(date);

  }

  // Function on load on screen
  loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }

  // Function check empty string
  checkUndefinedString(txt: string) {
    return this.GlobalService.checkUndefinedString(txt);
  }

  //Function check empty date
  checkUndefinedDate(date: string) {
    return this.GlobalService.checkUndefinedDate(date);

  }

  getContactlistRoleTier(val: string){
      if(val != "8"){
        if(val == "1" || val == "2"){
          return "1"; // tier 1
        }else if(val == "4" || val == "6"){
          return "2"; // tier 2
        }else if(val == "7"){
          return "3"; // tier 3
        }else{
          return null;
        }

      }else{
        return null;
      }
  }

  //Function uploadfile
  async uploadfile(file: File[]) {


    if (file != undefined && file.length > 0) {

      return await this.GlobalService.uploadFile(file, 'Resources/TicketUploadFile');


    } else {
      return false;
    }

  }


  // Function set Form control to Touched

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }


  checktypefileImgFromStr(traget) {
    return traget.match(/.(jpg|jpeg|png|gif)$/i);

  }

  PopupAttachImg(pathImg: string) {
    this.AttachImgPath = pathImg;
    $('#ModalAttachImg').show();

  }

  closeAttachImg() {
    $('#ModalAttachImg').hide();
  }
}
